module.exports = __webpack_public_path__ + "static/media/tm-colorit-11-sm.832e8a27.webp";